import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export const FormLayout = (props) => {
    const { children, className, ...rest } = props;
    return (_jsx("div", { className: clsx('space-y-5', className), ...rest, children: children }, void 0));
};
//# sourceMappingURL=Layout.js.map